import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const PrinterStack = styled(Stack, {
  shouldForwardProp: (prop) => !["selected"].includes(prop),
})(({ theme, selected }) => ({
  width: "100%",
  flexDirection: "row",
  alignItems: "center",
  padding: "5px 10px",
  cursor: "pointer",
  gap: "10px",
  ...(selected && {
    backgroundColor: theme.palette.hubColors.mainFocusLightest,
  }),
  ":hover": {
    backgroundColor: theme.palette.hubColors.greyLightest,
    ...(selected && {
      backgroundColor: theme.palette.hubColors.mainFocusLighter2,
    }),
  },
  ".MuiCheckbox-root": {
    width: "14px",
    height: "14px",
  },
}));
